
export const BASE_URL=process.env.REACT_APP_BASE_URL;
export const IMAGES_URL=process.env.REACT_APP_IMAGES_URL;
export const API_DOCS_URL = process.env.REACT_APP_API_DOCS_URL || '/api/v1/v3/api-docs';

export const getImageUrl = (filePath) => {
  return `${IMAGES_URL}/${filePath}`;
};
